import React from 'react';
import { Button } from '../ui/index.js';

interface LandingCtaBannerProps {
  onGuestClick: () => void;
}

export const LandingCtaBanner: React.FC<LandingCtaBannerProps> = ({ onGuestClick }) => {
  return (
    <section className="max-w-[1248px] mx-auto px-5 md:px-6 pt-6 md:pt-12 pb-12 md:pb-20">
      <div className="bg-base-200 border border-base-300 rounded-[22px] md:rounded-3xl p-7 md:p-12 flex flex-col md:flex-row md:items-center justify-between gap-4 md:gap-6 text-center md:text-right">
        <div>
          <h2 className="text-[22px] md:text-3xl font-extrabold m-0 text-base-content">
            <span className="hidden sm:inline">همین امروز تمرین را شروع کنید</span>
            <span className="sm:hidden">همین امروز شروع کنید</span>
          </h2>
          <p className="mt-1.5 md:mt-2 text-sm md:text-base text-base-content/60 m-0">
            بدون پرداخت، بدون نیاز به اینترنت.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center gap-2.5 sm:gap-3 w-full sm:w-auto mt-2 md:mt-0">
          <Button
            variant="primary"
            size="lg"
            href="/auth?mode=register"
            fullWidth
            className="sm:w-auto h-[52px] px-6 rounded-[14px] text-base font-bold justify-center"
          >
            ساخت حساب رایگان
          </Button>
          <Button
            variant="secondary"
            size="lg"
            onClick={onGuestClick}
            fullWidth
            className="hidden sm:inline-flex sm:w-auto h-[52px] px-6 rounded-[14px] text-base font-semibold justify-center"
          >
            امتحان بدون ثبت‌نام
          </Button>
        </div>
      </div>
    </section>
  );
};
